export default class Account {

  constructor(modelData, store) {

    this.store = store

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
  }

  getDefault() {
    return {
      id: null,
      name: null,
      description: null,
      isActive: true,
      isDemo: false,
      manageCustomer: false,
      validUntil: null,
      customerId: null,
      moduleIds: [],
      pluginIds: [],
      themeIds: [],
      type: 'L',
      parentId: null,
      storageUsage: null,
      totalStorageUsage: 0,
    }
  }

  getNumberAsMB(value) {
    if (value) {
      const mbValue = Math.trunc(value / 1024 / 1024)
      return this.getLocalNumber(mbValue)
    }

    else if (value === 0) {
      return 0
    }
    // if here, then the property is not in the response
    return 'NA'

  }

  getLocalNumber(num = 0) {
    return num.toLocaleString(this.store.getters.locale)
  }

  set(data) {
    Object.assign(this, data)

    if (this.themes && this.themes.data.length) {
      this.themeIds = this.themes.data.map(theme => {
        return {
          id: theme.id,
          // TODO: refactor so that i18n is accessible
          name: theme.translations['de'].name
        }
      })
    }

    if (this.plugins && this.plugins.data.length) {
      this.pluginIds = this.plugins.data.map(plugin => {
        return {
          id: plugin.id,
          // TODO: refactor so that i18n is accessible
          name: plugin.translations['de'].name
        }
      })
    }

    // convert Storage Usage to displayable property
    if (this.storageUsage && this.storageUsage.totalSize) {
      this.totalStorageUsage = this.getNumberAsMB(this.storageUsage.totalSize)
    }
    else {
      this.totalStorageUsage = 0
    }
  }

  getJSON() {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      isActive: this.isActive,
      isDemo: this.isDemo,
      manageCustomer: this.manageCustomer,
      validUntil: this.validUntil,
      customerId: this.customerId,
      moduleIds: this.moduleIds,
      pluginIds: this.pluginIds,
      themeIds: this.themeIds,
      type: this.type,
      parentId: this.parentId,
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/account/model.js